import { render, staticRenderFns } from "./MailListTab.vue?vue&type=template&id=5bb58dc8&"
import script from "./MailListTab.vue?vue&type=script&lang=js&"
export * from "./MailListTab.vue?vue&type=script&lang=js&"
import style0 from "./MailListTab.vue?vue&type=style&index=0&id=5bb58dc8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports